import React from "react";
import componentStyle from '@/styles/Component.scss';
import globalStyle from '@/styles/Global.scss'
import {User} from "@/entity/User";
import AttributeViewer from "@/components/AttributeViewer";

const ProfileViewer = ({ user = new User({})}) => {
  return (
    <>
      <div className={componentStyle.inputArea}>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>姓</div>
          <div className={globalStyle.value}>
            {user.familyName}
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>名</div>
          <div className={globalStyle.value}>
            {user.firstName}
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>姓フリガナ</div>
          <div className={globalStyle.value}>
            {user.familyNameKana}
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>名フリガナ</div>
          <div className={globalStyle.value}>
            {user.firstNameKana}
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>メールアドレス</div>
          <div className={globalStyle.value}>
            {user.mail}
          </div>
        </div>
        <AttributeViewer attributes={user.attributes} />
      </div>
    </>
  )
}
export default ProfileViewer
